export const CodePreview = {
  flex: 1,
  minWidth: 'G',
  maxHeight: '100%',
  overflow: 'auto',
  display: 'block',
  whiteSpace: 'pre-wrap',
  lineHeight: 1.8,
  fontSize: '0.765em',
  fontFamily: 'Code',
  round: 'A1',
  height: 'max-content',
  transition: 'B padding',
  padding: 'A_default A1_default',
  theme: 'common-card',
  value: '// demo code',
  // Dark tokens sit on `gray2.65` over the WORKSPACE stage, and a workspace
  // may paint a lighter stage (natali: gray5). Every hue clears 4.5:1 on the
  // card over the default stage AND over gray5; `keyword` was the one that
  // did not (3.73 on the gray5 card, measured live 2026-09-22).
  '& .token': {
    '&.keyword': {
      color: '#6592b9',
    },
    '&.string': {
      color: '#c8749c',
    },
    '&.punctuation': {
      color: '#A3A3A8',
    },
    '&.function': {
      color: '#c7c981',
    },
    '&.property': {
      color: '#87b6cb',
    },
    '&.string-property': {
      color: '#C584C0',
    },
    '&.operator': {
      color: '#74b6d4',
    },
    '&.boolean': {
      color: '#589BD6',
    },
    '&.number': {
      color: '#B5CFA8',
    },
    '&.comment': {
      color: '#6A9A55',
    },
    '&.constant': {
      color: '#fff',
    },
  },
  // The light palette: the same hues as the dark one, each darkened until it
  // clears 4.5:1 on BOTH light grounds a preview sits on (white — the light
  // `common-card` ground — and the gray15 stage). It used to reuse the dark
  // palette's own hexes for number / operator / boolean / comment, which read
  // 1.69–3.30 on white (measured live on the UI kit, 2026-09-22;
  // shared/__tests__/codePreviewSyntaxContrast.test.js recomputes every value).
  '@light': {
    '& .token': {
      '&.keyword': {
        color: '#126ebd',
      },
      '&.string': {
        color: '#cd2072',
      },
      '&.punctuation': {
        color: '#6a6a89',
      },
      '&.function': {
        color: '#7a6c00',
      },
      '&.property': {
        color: '#2b7393',
      },
      '&.string-property': {
        color: '#b633ac',
      },
      '&.operator': {
        color: '#2e7393',
      },
      '&.boolean': {
        color: '#2a70ad',
      },
      '&.number': {
        color: '#527540',
      },
      '&.comment': {
        color: '#517641',
      },
      '&.constant': {
        color: 'black',
      },
    },
  },
  onUpdate: (el, s) => {
      el.onRender(el, s)
    },
  onRender: async (el, s) => {
      const prismjs = await import('prismjs')
      // LIVENESS GATE — see getCodePreviewValue.js. The page can change while
      // prismjs loads, and smbls `dispose()` nulls `element.node` and
      // `element.parent`. Everything below this line reads the tree:
      // `getRootState`, `el.call` and `el.update`. The test is the dispose
      // signature, NOT `node.isConnected` — a child's onRender legitimately
      // runs before the root is attached.
      if (!el.node || !el.parent) return
      const Prism = prismjs?.default || prismjs
      const globalState = el.getRootState()
      const code = await el.call('getCodePreviewValue')
      if (!code || !Prism) return
      await el.update({
        html: Prism.highlight(
          code,
          Prism.languages.javascript,
          globalState?.language
        )
      }, {
        preventListeners: true,
        preventUpdateListener: true
      })
    },
};